export default __webpack_public_path__ + "static/media/greeting.8930d49b.svg";